<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Press Release Details</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <button type="submit" class="btn btn-warning btn-fill" @click="editPress">Edit Press Release</button>
                </div>
            </div>
            <div class="table-responsive" v-if="press">
                <table class="table table-bordered table-light">
                    <tr>
                        <th>Id</th>
                        <td>{{press.pressRoomContentId}}</td>
                    </tr>
                  <tr>
                    <th>Type</th>
                    <td><span v-if="press.contentOrder === 2">Press Release</span><span v-else>In the News</span></td>
                  </tr>
                  <tr>
                    <th>Date</th>
                    <td>{{press.topicSubHeadDateFmt}}</td>
                  </tr>
                  <tr>
                    <th>Heading</th>
                    <td>{{press.topicSubHead}}</td>
                  </tr>
                  <tr>
                    <th>Description</th>
                    <td>{{press.topicSubHeadContents}}</td>
                  </tr>
                  <tr>
                    <th>Attached Link</th>
                    <td><a :href="press.pdfUrl" :title="press.topicSubHead" target="_blank">{{press.pdfUrl}}</a></td>
                  </tr>
                    <tr>
                        <th>Status</th>
                        <td v-if="press.active == '0'">Inactive</td>
                        <td v-else>Active</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'ViewPress',
        components: {
            LTable,
        },
        created (){
        this.$store.dispatch('GETSELECTEDPRESS', this.$route.params.id).then(() =>{
            console.log('selected', this.selectedPress)
            this.press = this.selectedPress;
        })
    },
    data () {
        return {
          press: {}
        }
    },
    methods: {
        editPress(){
            this.$router.push({ name: 'EditPress', params: { id: this.press.pressRoomContentId}})
        },
    },
    computed: {...mapGetters([
        'selectedPress'])
    }
    }
</script>

<style>
    th{
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Press/PressDetails.vue